import HasID from "./HasID";
import HasLabel from "./HasLabel";

export enum TagEntityType {
    Drug = 0,
    Patient = 1,
    Prescriber = 2,
}

export interface Tag extends HasID {
    name: string;
    entityType: TagEntityType;
    rank: number;
    visibleMarking?: string;
    defaultUrgency: boolean;
    promiseTimeOffsetHours?: number;
    shipOvernight: boolean;
    overridePriority: boolean;
    disableOneRate: boolean;
    signatureRequired: boolean;
    shipToPrescriber: boolean;
    blockRefillRequests: boolean;
    taskTemplateId?: number;
    notes?: string;
    created: Date;
    createdBy: string;
    updated: Date;
    updatedBy: string;
}

export class Tag extends HasLabel {
    constructor(obj?: Tag) {
        super();
        if (obj) {
            Object.assign(this, obj);
        }
    }

    toString(): string {
        if (this.name)
            return `ID:${this.id} ${this.name}`;
        else return '';
    }
}
